import clsx from 'clsx'
import React, { FC } from 'react'

import styles from './ProgressLineIndicator.module.scss'
import stylesV2 from './ProgressLineIndicatorV2.module.scss'

export interface ProgressLineIndicatorProps {
  className?: string
  progress: number
  showEndIndicator?: boolean
  v2?: boolean
}

export const ProgressLineIndicator: FC<ProgressLineIndicatorProps> = ({ className, progress, showEndIndicator, v2 }) => (
  <div className={clsx(v2 ? stylesV2.progressLineIndicator : styles.progressLineIndicator, className)}>
    <div
      className={clsx(
        v2 ? stylesV2.milestoneIndicator : styles.milestoneIndicator,
        showEndIndicator && progress > 0 && (v2 ? stylesV2.minIndicatorWidth : styles.minIndicatorWidth),
        progress === 100 && (v2 ? stylesV2.reached : styles.reached),
      )}
      style={{ width: `${progress}%` }}
    >
      {showEndIndicator && <div className={v2 ? stylesV2.endLineIndicator : styles.endLineIndicator} />}
    </div>
  </div>
)

